var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.paraMaterials),function(material){return _c(material.component,{key:material.id,tag:"component",attrs:{"material-view":material},on:{"materialEvent":_vm.materialEventHandler}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }